module.exports = __webpack_public_path__ + "ath_game_web/img/2.2.153aef2b.png";